import URL from '@/creditflowresearch/Router/urlConstants';

export const THEME_STORAGE_KEY = 'cfr-theme';

// TODO: dark-theme — remove this list once all pages support dark theme.
// At that point, forcedTheme logic in _app.tsx and the ThemeToggle visibility
// check in HeaderLayoutDesktop should also be removed.
export const DARK_THEME_PAGES: string[] = [
  URL.EUROPE_ACTIVE_CALENDAR,
  URL.CORPORATE_ACTIVE_CALENDAR,
];
